/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostscolumnfeature3Inputs */

const en_aicostscolumnfeature3 = /** @type {(inputs: Aicostscolumnfeature3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature`)
};

const de_aicostscolumnfeature3 = /** @type {(inputs: Aicostscolumnfeature3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktion`)
};

/**
* | output |
* | --- |
* | "Feature" |
*
* @param {Aicostscolumnfeature3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostscolumnfeature3 = /** @type {((inputs?: Aicostscolumnfeature3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostscolumnfeature3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostscolumnfeature3(inputs)
	return de_aicostscolumnfeature3(inputs)
});
export { aicostscolumnfeature3 as "aiCostsColumnFeature" }